import { useState } from 'react'
import { Label } from '@/common/ui/label'
import { Button } from '@/common/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/common/ui/popover'
import { ScrollArea, ScrollBar } from '@/common/ui/scroll-area'
import { Clock } from 'lucide-react'
import { cn } from '@/common/lib/utils'

interface IntervalTimePickerProps {
	value: string
	onChange: (value: string) => void
	disabled?: boolean
}

export const IntervalTimePicker = ({
	value,
	onChange,
	disabled,
}: IntervalTimePickerProps) => {
	const [isOpen, setIsOpen] = useState(false)

	// Parse current time value
	const [hours, minutes] = value ? value.split(':') : ['09', '00']

	// Generate hours and minutes arrays
	const hoursArray = Array.from({ length: 24 }, (_, i) =>
		i.toString().padStart(2, '0'),
	)
	const minutesArray = Array.from({ length: 60 }, (_, i) =>
		i.toString().padStart(2, '0'),
	)

	const handleTimeChange = (type: 'hour' | 'minute', val: string) => {
		const [currentHour, currentMinute] = value ? value.split(':') : ['09', '00']
		const newTime =
			type === 'hour' ? `${val}:${currentMinute}` : `${currentHour}:${val}`
		onChange(newTime)
	}

	return (
		<div className="space-y-2">
			<Label>เวลาส่ง</Label>
			<Popover open={isOpen} onOpenChange={setIsOpen}>
				<PopoverTrigger asChild>
					<Button
						variant="outline"
						disabled={disabled}
						className={cn(
							'w-full justify-start text-left font-normal',
							!value && 'text-muted-foreground',
						)}
					>
						<Clock className="mr-2 h-4 w-4" />
						{value || 'เลือกเวลา'}
					</Button>
				</PopoverTrigger>
				<PopoverContent className="w-auto p-0" align="start">
					<div className="flex">
						<ScrollArea className="h-[200px]">
							<div className="flex flex-col p-2">
								{hoursArray.map((hour) => (
									<Button
										key={hour}
										size="sm"
										variant={hours === hour ? 'default' : 'ghost'}
										className="shrink-0 justify-center"
										onClick={() => handleTimeChange('hour', hour)}
									>
										{hour}
									</Button>
								))}
							</div>
							<ScrollBar orientation="vertical" />
						</ScrollArea>
						<ScrollArea className="h-[200px]">
							<div className="flex flex-col p-2">
								{minutesArray.map((minute) => (
									<Button
										key={minute}
										size="sm"
										variant={minutes === minute ? 'default' : 'ghost'}
										className="shrink-0 justify-center"
										onClick={() => handleTimeChange('minute', minute)}
									>
										{minute}
									</Button>
								))}
							</div>
							<ScrollBar orientation="vertical" />
						</ScrollArea>
					</div>
				</PopoverContent>
			</Popover>
			<p className="text-sm text-muted-foreground">
				เวลาตามเขตเวลาประเทศไทย (GMT+7)
			</p>
		</div>
	)
}
